var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 98,
    viewBox: "0 0 97 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Button_style_",
    x: 0,
    y: 0,
    width: 97,
    height: 98,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.039
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Button_style_2",
    x: 3,
    y: 4,
    width: 91,
    height: 90,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.039
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(19.082 8.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1883",
    "data-name": "Group 1883",
    transform: "translate(0 -0.82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.08, -7.2)",
    filter: "url(#Button_style_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button_style_3",
    "data-name": "Button (style)",
    transform: "translate(19.5 7.5)",
    fill: "#fff",
    stroke: "#efefef",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 59,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 57,
    rx: 11,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.08, -7.2)",
    filter: "url(#Button_style_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button_style_4",
    "data-name": "Button (style)",
    transform: "translate(22.5 11.5)",
    fill: "none",
    stroke: "#c9d0d6",
    strokeWidth: 2,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 51,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 49,
    rx: 11,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_image_filled",
    "data-name": "UI icon/image/filled",
    transform: "translate(15.841 15.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M23.212,27.308H4.1a4.1,4.1,0,0,1-4.1-4.1V4.1A4.1,4.1,0,0,1,4.1,0H23.212a4.1,4.1,0,0,1,4.1,4.1V23.212A4.1,4.1,0,0,1,23.212,27.308ZM8.68,8.951v0a4.084,4.084,0,0,0-3.147,1.474L3.047,13.41a1.376,1.376,0,0,0-.317.876v8.927A1.366,1.366,0,0,0,4.1,24.576H23.212c.037,0,.076,0,.112,0a.515.515,0,0,0,.473-.333,1.078,1.078,0,0,0-.272-1.042L11.7,10.282A4.05,4.05,0,0,0,8.68,8.953ZM20.48,4.1a2.731,2.731,0,1,0,2.732,2.732A2.734,2.734,0,0,0,20.48,4.1Z",
    transform: "translate(0 0)",
    fill: "#92979c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/uploadImageIcon.950186f29524bcbe5ff93fe42c6b9a4f.svg";
export { ForwardRef as ReactComponent };